import React, { useState } from 'react';
import { Mail, Phone, Send, MessageCircle, MapPin, Building2 } from "lucide-react";
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Textarea } from '../components/ui/textarea';
import { toast } from '../hooks/use-toast';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Create mailto link with form data
    const subject = encodeURIComponent(`İletişim Formu - ${formData.name}`);
    const body = encodeURIComponent(
      `İsim: ${formData.name}\nE-posta: ${formData.email}\nTelefon: ${formData.phone}\n\nMesaj:\n${formData.message}`
    );
    
    // Open email client
    window.location.href = `mailto:goomoreinternational@gmail.com?subject=${subject}&body=${body}`;
    
    // Show success toast
    toast({
      title: 'Mesajınız Hazırlandı!',
      description: 'E-posta istemciniz açılacak. Lütfen mesajı gönderin.',
    });
    
    // Reset form
    setFormData({ name: '', email: '', phone: '', message: '' });
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <div className="min-h-screen bg-gray-50 pt-20">
      {/* Header */}
      <section className="bg-gradient-to-br from-[#001F3F] to-[#003366] text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">İletişim</h1>
          <p className="text-xl text-white/90 max-w-3xl">
            Sorularınız ve önerileriniz için bize ulaşabilirsiniz.
          </p>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12">
            {/* Contact Info */}
            <div>
              <h2 className="text-3xl font-bold text-[#001F3F] mb-8">İletişim Bilgileri</h2>
              
              <div className="space-y-6">
                <div className="mt-6 flex items-start space-x-4 p-6 bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300">
                  <div className="p-3 bg-[#001F3F]/10 rounded-lg">
                    <Phone size={24} className="text-[#001F3F]" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-[#001F3F] mb-1">Telefon</h3>
                    <a href="tel:+905372101452" className="text-gray-600 hover:text-[#001F3F] transition-colors">
                      +90 537 210 14 52
                    </a>
                  </div>
                </div>


                <div className="mt-6 flex items-start space-x-4 p-6 bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300">
                  <div className="p-3 bg-[#001F3F]/10 rounded-lg">
                    <MessageCircle size={24} className="text-[#001F3F]" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-[#001F3F] mb-1">WhatsApp</h3>
                    <button 
                      onClick={() => window.open('https://wa.me/905372101452', '_blank')}
                      className="text-gray-600 hover:text-[#001F3F] transition-colors"
                    >
                      WhatsApp ile iletişime geç
                    </button>
                  </div>
                </div>

                <div className="mt-6 flex items-start space-x-4 p-6 bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300">
                  <div className="p-3 bg-[#001F3F]/10 rounded-lg">
                    <Mail size={24} className="text-[#001F3F]" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-[#001F3F] mb-1">E-posta</h3>
                    <a href="mailto:goomoreinternational@gmail.com" className="text-gray-600 hover:text-[#001F3F] transition-colors">
                      goomoreinternational@gmail.com
                    </a>
                  </div>
                </div>
              </div>

<div className="mt-6 flex items-start space-x-4 p-6 bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300">
  <div className="p-3 bg-[#001F3F]/10 rounded-lg">
    <MapPin size={24} className="text-[#001F3F]" />
  </div>

  <div>
    <h3 className="text-lg font-semibold text-[#001F3F] mb-1">
      Adres
    </h3>

    <p className="text-gray-600">
      Genç Osman Mah.
      <br />
      Pınar Sok. No:9
      <br />
      Güngören / İstanbul
    </p>
  </div>
</div>


<div className="mt-6 p-6 bg-gradient-to-br from-[#001F3F] to-[#003366] rounded-xl text-white">

  <div className="flex items-center gap-3 mb-4">

    <Building2 />

    <h3 className="text-xl font-semibold">
      Şirket Bilgileri
    </h3>

  </div>

<div className="space-y-4 text-white/90 text-sm">
  <p>
    <strong>Ünvan:</strong><br />
    One Shop E-ticaret Kozmetik Ürünleri Ticaret LTD. ŞTİ.
  </p>

  <p>
    <strong>Adres:</strong><br />
    Genç Osman Mah.<br />
    Pınar Sok. No:9<br />
    Güngören / İstanbul
  </p>

  <p>
    <strong>Telefon:</strong><br />
    0537 210 14 52
  </p>

  <p>
    <strong>E-posta:</strong><br />
    goomoreinternational@gmail.com
  </p>

  <p>
    <strong>Vergi Dairesi:</strong><br />
    Esenler Vergi Dairesi
  </p>

  <p>
    <strong>Vergi No:</strong><br />
    6430860629
  </p>
</div>
</div>
              <div className="mt-8 p-6 bg-gradient-to-br from-[#001F3F] to-[#003366] rounded-xl text-white">
                <h3 className="text-xl font-semibold mb-3">Hızlı İletişim</h3>
                <p className="mb-4 text-white/90">
                  Detaylı bilgi için WhatsApp hattımızdan bize ulaşabilirsiniz.
                </p>
                <Button 
                  onClick={() => window.open('https://wa.me/905372101452', '_blank')}
                  className="w-full bg-white text-[#001F3F] hover:bg-gray-100"
                >
                  WhatsApp ile Yaz
                </Button>
              </div>
            </div>

            {/* Contact Form */}
            <div>
              <h2 className="text-3xl font-bold text-[#001F3F] mb-8">Mesaj Gönderin</h2>
              
              <form onSubmit={handleSubmit} className="bg-white rounded-xl shadow-lg p-8">
                <div className="space-y-6">
                  <div>
                    <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                      Adınız Soyadınız
                    </label>
                    <Input
                      id="name"
                      name="name"
                      type="text"
                      required
                      value={formData.name}
                      onChange={handleChange}
                      className="w-full"
                      placeholder="Adınız ve soyadınız"
                    />
                  </div>

                  <div>
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                      E-posta Adresiniz
                    </label>
                    <Input
                      id="email"
                      name="email"
                      type="email"
                      required
                      value={formData.email}
                      onChange={handleChange}
                      className="w-full"
                      placeholder="ornek@email.com"
                    />
                  </div>

                  <div>
                    <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2">
                      Telefon Numaranız
                    </label>
                    <Input
                      id="phone"
                      name="phone"
                      type="tel"
                      required
                      value={formData.phone}
                      onChange={handleChange}
                      className="w-full"
                      placeholder="+90 5XX XXX XX XX"
                    />
                  </div>

                  <div>
                    <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
                      Mesajınız
                    </label>
                    <Textarea
                      id="message"
                      name="message"
                      required
                      value={formData.message}
                      onChange={handleChange}
                      rows={6}
                      className="w-full"
                      placeholder="Mesajınızı buraya yazın..."
                    />
                  </div>

                  <Button 
                    type="submit"
                    className="w-full bg-[#001F3F] hover:bg-[#003366] text-white py-3 text-base font-semibold"
                  >
                    Mesaj Gönder
                    <Send className="ml-2" size={18} />
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;